import React, { useEffect, useState } from 'react';

import clsx from 'clsx';
import { useParams } from 'react-router-dom';
import { useTrail, animated } from 'react-spring';

import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';

import TrainingCard from 'components/TrainingGrid/TrainingCard';

import { storageKeys } from 'settings';

const trackShare = (chapterNumber) => {
  const value = `chapter-${chapterNumber}`;
  const appId = DataHandler.matchAppId();

  StorageHandler.load(storageKeys.user).then((userObj) => {
    let email = '';
    ({ email } = userObj.response);
    APIHandler.trackEvent(appId, email, 'retention', 'chapter', value).then(() => {});
  });
};

const calculateProgress = ({ chapters }) =>
  chapters.map((chapter) => ({
    ...chapter,
    percentage:
      chapter.progress > 0 && chapter.total_pages > 0
        ? Math.min((chapter.progress / chapter.total_pages) * 100, 100)
        : 0,
  }));

const getProgress = async (callback) => {
  const { response: user } = (await StorageHandler.load(storageKeys.user)) || {};
  await APIHandler.registerUserProgress(user.email);
  if (user.email) {
    const appId = DataHandler.matchAppIdSync();

    const { data } = (await APIHandler.getUserProgress(appId, user.email)) || {};
    const [userData] = data;
    const progress = calculateProgress(userData);

    const { app: chapters } = await APIHandler.getChapters(appId);
    console.log(APIHandler.getChapters(appId));
    callback(chapters.map((chapter, i) => ({ ...chapter, ...progress[i] })));
  }
};

const animation = {
  from: { opacity: 0, transform: 'translateY(10%)' },
  to: { opacity: 1, transform: 'translateY(0%)' },
};

const TrainingGrid = () => {
  const [chapters, setChapters] = useState([]);
  const [trail, set] = useTrail(chapters.length, () => animation.from);
  const { type } = useParams();

  useEffect(() => {
    getProgress(setChapters);
  }, []);

  useEffect(() => {
    if (chapters.length > 0) set(animation.to);
  }, [chapters, set]);

  return (
    <div className={clsx('wrapper__grid', type)}>
      <div className="trainingGrid">
        {chapters.length > 0 &&
          trail.map((props, i) => (
            <animated.div
              key={chapters[i].chapter}
              className="trainingCard__Animated"
              style={props}
              onClick={() => trackShare(chapters[i].chapter)}
            >
              <TrainingCard index={i} {...chapters[i]} locked={chapters[i - 1]?.percentage < 100} />
            </animated.div>
          ))}
      </div>
    </div>
  );
};

export default TrainingGrid;
